import React, { Fragment } from "react";

function Footer(props) {
  return (
    <Fragment>
      <footer className="py-1">
        <p className="text-center mt-1">
          EBuy &copy; - 2021-2022, All Rights Reserved
        </p>
      </footer>
    </Fragment>
  );
}

export default Footer;
